<div class="box card-box" layout="column">
  <div class="box-header">
    <h6 *ngIf="loading else showHeaderBlock" skeleton-text class="skeleton-effect-wave">
      {{ currentFileName }}
    </h6>
    <ng-template #showHeaderBlock>
      <h6>{{ currentFileName }}</h6>
      <div>
        <a *ngIf="preview"
           [download]="preview.download"
           [href]="preview.href"
           [attr.test-id]="'downloadButton'"
           target="_blank"
           rel="noopener"
           class="btn btn-md btn-icon">
          <i aria-hidden="true" class="fa fa-light fa-download"></i>
        </a>
        <a *ngIf="deletable"
           (click)="deleteDocument()"
           target="_blank"
           rel="noopener"
           class="btn btn-md btn-icon">
          <em class="fa fa-light fa-trash text-danger"></em>
        </a>
        <button [attr.test-id]="'closeButton'"
                (click)="closeSidePanel()"
                class="btn btn-md btn-icon">
          <i aria-hidden="true" class="fa fa-light fa-times text-primary"></i>
        </button>
      </div>
    </ng-template>
  </div>
  <div class="box-body no-padding">
    <skeleton-block *ngIf="loading else everythingIsLoaded"
                    class="skeleton-block"
                    effect="wave">
    </skeleton-block>

    <ng-template #everythingIsLoaded>
      <ng-container *ngIf="error else noPreviewErrorBlock">

        <gp-illustrated-message *ngIf="!documentsLimitReached"
                                [type]="'SOMETHING_WRONG'"
                                [text]="'COMMON.something_went_wrong'">
        </gp-illustrated-message>
        <gp-illustrated-message *ngIf="documentsLimitReached"
                                [type]="'FORBIDDEN'"
                                [text]="'DOCUMENTS.generate_limit_reached'">
        </gp-illustrated-message>
      </ng-container>

      <ng-template #noPreviewErrorBlock>
        <gp-illustrated-message *ngIf="!preview"
                                [text]="'DOCUMENTS.no_preview'">
        </gp-illustrated-message>
        <gp-illustrated-message *ngIf="noSupportedFormat && preview"
                                [type]="'NOT_SUPPORTED'"
                                [text]="'DOCUMENTS.no_supported_format'">
        </gp-illustrated-message>
      </ng-template>
      <div [attr.test-id]="'iframe'" *ngIf="!noSupportedFormat && preview && !error"
           [innerHtml]="preview.iframe">
      </div>
    </ng-template>
  </div>
</div>

